<mat-chip-list aria-label="Custom label">
  <mat-chip
    *ngFor="let label of labels"
    [removable]="removable"
    (removed)="onRemove(label.text)"
    [matTooltip]="label.reason"
    [matTooltipDisabled]="!tooltip"

  >
    <span [innerHTML]="label.text | tcSafeLineBreak"></span>
    <ng-container *ngIf="removable">
      <mat-icon matChipRemove>cancel</mat-icon>
    </ng-container>
  </mat-chip>
</mat-chip-list>
